var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasNoVerifiedEmail && _vm.answeredTermsOfUse
    ? _c(
        "warning-card",
        [
          _c(
            "notice",
            {
              attrs: {
                icon: "/static/mail.svg",
                title: _vm.title,
                subtitle:
                  "Para criar um pedido o seu e-mail deve estar verificado."
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn bg-pink-outline mt-15",
                  on: {
                    click: function($event) {
                      _vm.showEmailNotVerifiedDialog()
                    }
                  }
                },
                [_vm._v("verificar e-mail")]
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f99d96b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f99d96b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Warnings/EmailNotVerified/Notice.vue
// module id = null
// module chunks = 